<template>
    <div>
        <ul class="nav nav-tabs">
            <li v-for="(tab, index) in tabs" class="nav-item" :key="index">
                <a :class="setActiveTabClasses(tab)" data-toggle="tab" :href="tab.href" @click="selectTab(tab)">
                    {{ tab.name }}
                </a>
            </li>
        </ul>

        <div class="tab-content mt-3">
            <slot></slot>
        </div>
    </div>
</template>

<script>
    export default {
        data() {
            return { tabs: [] };
        },

        created() {
            this.tabs = this.$children;
        },

        mounted() {
            // select active tab according to anchor
            if(window.location.hash !== '') {
                this.tabs.forEach(tab => {
                    tab.isActive = (tab.href == window.location.hash);
                });
            }
        },

        methods: {
            selectTab(selectedTab) {
                this.tabs.forEach(tab => {
                    tab.isActive = (tab.href == selectedTab.href);
                });

                window.location.href = selectedTab.href;
            },

            setActiveTabClasses(tab) {
                return tab.isActive ? 'nav-link active' : 'nav-link';
            }
        }
    }
</script>

<style lang="scss">


</style>